import React from 'react';
import PropTypes from 'prop-types';

import {dispatch, connect} from 'utils/state_manager';

import backend from 'utils/backend';
import moment from 'moment';

const TaskCounter = (props) => {
  const {
    user,
    taskRefreshSetMyTasksCount,
    taskRefreshSetAllTasksCount,
  } = props;

  React.useEffect(() => {
    const loadTaskCounts = async () => {
      if (!user?.userRn) {
        taskRefreshSetMyTasksCount(0);
        taskRefreshSetAllTasksCount(0);
        return;
      }

      try {
        const oneWeekAgoUtc = moment().startOf('day').subtract(1, 'week').utc();
        const endOfTodayUtc = moment().endOf('day').utc();
        const endOfWeekUtc = moment().endOf('isoWeek').utc();

        const startDate = Math.floor(new Date(oneWeekAgoUtc.toISOString()).getTime());
        const endOfWeekDate = Math.floor(new Date(endOfWeekUtc.toISOString()).getTime());
        const endOfTodayDate = Math.floor(new Date(endOfTodayUtc.toISOString()).getTime());
        const taskSortBy = {sortKey: 'dueDate', sortDirection: 'ASC'};
        const companyTaskFilters = [
          {key: 'dueDate', value: `[${startDate} TO ${endOfWeekDate}]`},
          {key: 'status', value: ['OPEN', 'IN_PROGRESS']},
        ];
        const userTaskFilters = [
          {key: 'resourceRn', value: user.userRn},
          {key: 'dueDate', value: `[${startDate} TO ${endOfTodayDate}]`},
          {key: 'status', value: ['OPEN', 'IN_PROGRESS']},
        ];
        const userTasks = await backend.workflowEngine.queryResourceTasks(userTaskFilters, taskSortBy, null);

        taskRefreshSetMyTasksCount(userTasks?.list?.length ?? 0);

        const allTasks = await backend.workflowEngine.queryCompanyTasks(companyTaskFilters, taskSortBy, null);

        taskRefreshSetAllTasksCount((allTasks?.list?.length ?? 0) >= 100 ? 1000000 : (allTasks?.list?.length ?? 0));
        // Setting to large sentinel value if # of tasks > 99 so it doesn't show incorrect count when # of tasks are modified
      } catch (error) {
        console.error('Failed to sync task counts', error);

        taskRefreshSetMyTasksCount(0);
        taskRefreshSetAllTasksCount(0);
      }
    };

    loadTaskCounts();
  }, [taskRefreshSetAllTasksCount, taskRefreshSetMyTasksCount, user?.userRn]);

  return null;
};

TaskCounter.propTypes = {
  user: PropTypes.object,
  taskRefreshSetMyTasksCount: PropTypes.func.isRequired,
  taskRefreshSetAllTasksCount: PropTypes.func.isRequired,
};

const mapStateToProps = (state) => ({
  user: state.user,
});

export default connect(mapStateToProps, dispatch)(React.memo(TaskCounter));
